import { useEffect, useRef, useState } from 'react';
import { fetchSharedOnlySettings } from '../../../components/messaging/canonicalMessagingApi';
import { createSharedOnlyMonitor } from '../models/sharedOnlyMonitor';
export function useSharedOnlyMonitor(socket, connected, authenticated, actorId, canRead) {
  const [policy, setPolicy] = useState({ actorId: null, known: false, enabled: false });
  const coordinator = useRef(null);
  useEffect(() => {
    if (!socket || !authenticated) return;
    const monitor = createSharedOnlyMonitor({ read: fetchSharedOnlySettings, update: value => setPolicy({ ...value, actorId }) });
    coordinator.current = monitor;
    socket.on('messaging.shared_only.changed', monitor.receive);
    return () => { monitor.dispose(); socket.off('messaging.shared_only.changed', monitor.receive); coordinator.current = null; };
  }, [socket, authenticated, actorId]);
  useEffect(() => {
    // Staff-readable contract: failure is never interpreted as OFF.
    if (authenticated && connected && canRead) coordinator.current?.reconcile();
  }, [socket, authenticated, actorId, connected, canRead]);
  return authenticated && policy.actorId === actorId ? policy : { known: false, enabled: false };
}
